import type { ValueOf } from '@common/utils/utilityTypes';

export const YesNoNoDeviations = {
    no: 'Nee',
    no_deviations: 'Geen afwijkingen',
    yes: 'Ja',
} as const;

export type YesNoNoDeviations = ValueOf<typeof YesNoNoDeviations>;
